import {
  CreateHiringPhaseDocument,
  CreateHiringPhaseMutation,
  CreateHiringPhaseMutationVariables,
  GetHiringStagesDocument,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

export const useCreateHiringPhase = () => {
  const [createAtsHiringPhase, { loading }] = useMutation(CreateHiringPhaseDocument, {
    extractorFn: (data: CreateHiringPhaseMutation) => data.atsMutations.createAtsHiringPhase,
  })

  return {
    loading,
    create(variables: CreateHiringPhaseMutationVariables) {
      return createAtsHiringPhase({
        variables,
        refetchQueries: [GetHiringStagesDocument],
      })
    },
  }
}
